import React, { useState } from "react";

const sortIndex = {
  "1": "-up",
  "0": "",
  "-1": "-down"
};

const CustomTableHeader = ({
  handleSort,
  orderBy,
  sortBy,
  excludeSort = []
}) => headerGroups => {
  return (
    <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column, idx) => {
            // reload sort order from component state if necessary; this is so sorting plays nice with infinite scroll
            // if (sortState.idx === idx && !column.isSorted)
            //   column.toggleSortBy(sortState.order, false);

            // hacky, modified version of ...column.getHeaderProps(column.getSortByToggleProps()) to support that

            const sortable = !excludeSort.includes(column.id);
            return (
              <th
                className={sortable ? "cursor-pointer" : ""}
                onClick={e => {
                  if (sortable) handleSort(column);
                }}
                key={column.id}
              >
                <div className="flex items-center">
                  {" "}
                  {/* justify-between to put arrows on the right */}
                  <span>{column.render("Header")}</span>
                  {sortable && (
                    <i
                      className={`ml-1 fa fa-sort${
                        sortBy === column.id ? sortIndex[orderBy] : ""
                      }`}
                    />
                  )}
                </div>
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};

export default CustomTableHeader;
